import { INBOUND_REFERRALS_ROUTES } from '../constants';

// The Tasks surface is ONE route with a tab parameter, not two routes: the header, the scan
// banner and the Manage Connected Portals link are shared, and a second route would duplicate
// all three. `/inbound-referrals/tasks` is the Tasks tab; the tab segment names the others.
export const TASKS_ROUTES = {
  BASE: `${INBOUND_REFERRALS_ROUTES.BASE}/tasks`,
};

export const TASK_TABS = ['tasks', 'portalScans'] as const;
export type TaskTab = (typeof TASK_TABS)[number];

// URL segment <-> tab. Kept explicit rather than derived so the segment can read as a URL
// ('portal-scans') while the tab reads as code.
const TAB_SEGMENTS: Record<TaskTab, string> = { tasks: 'tasks', portalScans: 'portal-scans' };

export function tabFromSegment(segment: string | undefined): TaskTab | null {
  if (!segment) return 'tasks';
  return (TASK_TABS.find((tab) => TAB_SEGMENTS[tab] === segment) as TaskTab | undefined) ?? null;
}

export function tabPath(tab: TaskTab): string {
  return tab === 'tasks' ? TASKS_ROUTES.BASE : `${TASKS_ROUTES.BASE}/${TAB_SEGMENTS[tab]}`;
}

export const TAB_LABELS: Record<TaskTab, string> = { tasks: 'Tasks', portalScans: 'Portal Scans' };

// The portal action kinds the card derivation branches on. Strings, not an enum: they're the
// api's own class basenames (WorkflowAction#kind), and a mistyped one must fail a test rather
// than fail to compile into something plausible.
export const ACTION_KINDS = {
  retrieve: 'RetrievePortalInformation',
  mapFacilities: 'MapPortalFacilities',
  dispose: 'DisposePortalReferral',
  discover: 'DiscoverPortalActivity',
  // The sweep's own dispose — records the verdicts and spawns the retrieval runs. Distinct
  // from `dispose`, which is the retrieval workflow's.
  disposeSweep: 'DisposePortalActivity',
} as const;
